(function () {
if (window.__MD_BLACK_FRIDAY) { window.__MD_BLACK_FRIDAY.scan(); return; }

var CFG = { end: '2026-11-22T23:59:59+01:00', tiers: [250, 400], gallery: 0, deals: {} };
function configure() {
var countdown = document.querySelector('[data-mbf-config-end]');
if (countdown) { CFG.end = countdown.getAttribute('data-mbf-config-end'); }
END = Date.parse(CFG.end);
if (!isFinite(END)) { END = 0; }
var tiers = document.querySelector('[data-mbf-config-tiers]');
if (tiers) {
cur = tiers.getAttribute('data-currency') || cur;
CFG.country = tiers.getAttribute('data-country');
CFG.region = tiers.getAttribute('data-region');
var rawRate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
rate = cur === 'EUR' ? 1 : tiers.getAttribute('data-base-currency') === 'EUR' && rawRate > 0 && isFinite(rawRate) ? rawRate : null;
var one = +tiers.getAttribute('data-tier-1'), two = +tiers.getAttribute('data-tier-2');
CFG.tiers = [one > 0 ? one : 250, two > one && two > 0 ? two : Math.max(400, one + 1)];
}
CFG.deals = {};
$$('[data-mbf-deal]').forEach(function (el) {
CFG.deals[el.getAttribute('data-mbf-deal')] = { handle: el.getAttribute('data-handle'), variant: el.getAttribute('data-variant'), normalEUR: Number(el.getAttribute('data-normal-eur')) || 0 };
});
}
function label(key, fallback, el) {
var owner = el && (el.closest('[data-mbf-section]') || el.closest('[data-mbf-owner]'));
var scope = owner || document.querySelector('[data-mbf-labels]');
return scope && scope.getAttribute('data-label-' + key) || fallback;
}
var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
var rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1') || 1;
var lang = (document.documentElement.lang || 'en').slice(0, 2);
var END = Date.parse(CFG.end);
var DEMO = window.MBF_DEMO || null, demoCart = { total_price: 0, item_count: 0 };
function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
function money(c) {
try { return new Intl.NumberFormat(lang === 'en' ? 'en-IE' : lang, { style: 'currency', currency: cur }).format(c / 100); }
catch (e) { return '\u20ac' + (c / 100).toFixed(2); }
}
function pad(n) { return (n < 10 ? '0' : '') + n; }
function tick() {
var left = Math.max(0, END - Date.now()), s = Math.floor(left / 1000);
var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
$$('[data-mbf-cd]').forEach(function (el) {
$$('[data-u]', el).forEach(function (b) { var t = pad(v[b.getAttribute('data-u')]); if (b.textContent !== t) { b.textContent = t; } });
el.classList.toggle('is-over', left === 0);
});
}

var prods = {};
function product(handle) {
if (prods[handle]) { return prods[handle]; }
prods[handle] = (DEMO || !window.fetch) ? Promise.resolve(null) : window.fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
.then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
return prods[handle];
}
function variantOf(p, id) { var v = null; (p.variants || []).forEach(function (x) { if (x.id === +id) { v = x; } }); return v; }
function imgUrl(u, w) { if (!u) { return ''; } u = (u.indexOf('//') === 0 ? 'https:' : '') + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
function paintDeal(key) {
var d = CFG.deals[key]; if (!d) { return; }
product(d.handle).then(function (p) {
if (!p) { return; }
var v = d.variant ? variantOf(p, d.variant) : (p.variants || []).find(function (v) { return v.available; });
if (!v) { d.available = false; return; }
d.available = v.available;
$$('[data-mbf-buy="' + key + '"]').forEach(function (button) {
button.disabled = !v.available;
var text = button.querySelector('.mbf-btn__t');
if (!v.available && text) { text.textContent = label('soldout', 'Sold out', button); }
});
d.variant = v.id;
var normal = key === 'bogo' ? (rate ? v.price + Math.round(7000 * rate) : 0) : d.normalEUR ? (rate ? Math.round(d.normalEUR * 100 * rate) : 0) : v.compare_at_price;
var has = normal && normal > v.price;
$$('[data-mbf-price="' + key + '"]').forEach(function (box) {
box.classList.toggle('is-nocompare', !has);
$$('[data-mbf-now]', box).forEach(function (e) { e.textContent = money(v.price); });
if (has) {
$$('[data-mbf-was]', box).forEach(function (e) { e.textContent = money(normal); });
$$('[data-mbf-save]', box).forEach(function (e) { e.textContent = money(normal - v.price); });
$$('[data-mbf-pct]', box).forEach(function (e) { e.textContent = '-' + Math.round((1 - v.price / normal) * 100) + '%'; });
}
});
$$('[data-mbf-buy="' + key + '"],[data-mbf-open="' + key + '"]').forEach(function (b) { b.setAttribute('data-cents', v.price); });

var max = CFG.gallery || 0, imgs = (p.images || []).slice(0, max);
$$('[data-mbf-gal="' + key + '"]').forEach(function (g) {
if (g.getAttribute('data-live')) { return; } g.setAttribute('data-live', '1');
imgs.forEach(function (u) { addThumb(g, imgUrl(u, 1000), imgUrl(u, 160), true); });
galNav(g);
});
});
}
function paintRegs() {
$$('[data-mbf-vprice]').forEach(function (el) {
var parts = el.getAttribute('data-mbf-vprice').split('|');
product(parts[0]).then(function (p) { var v = p && variantOf(p, parts[1]); if (v) { el.textContent = money(v.price); } });
});
}

function cardState(card) {
var on = card.querySelector('.mbf-var.is-on') || card.querySelector('[data-v]');
if (!on) { return; }
var price = +on.getAttribute('data-price'), was = +on.getAttribute('data-was') || 0, ok = on.getAttribute('data-ok') === '1';
card.querySelector('[data-mbf-cnow]').textContent = money(price);
var s = card.querySelector('[data-mbf-cwas]'); if (s) { s.textContent = was > price ? money(was) : ''; }
var add = card.querySelector('[data-mbf-qadd]'), lbl = add.querySelector('.mbf-card__lbl');
add.disabled = !ok; add.setAttribute('data-v', on.getAttribute('data-v')); add.setAttribute('data-cents', price);
if (lbl) { lbl.textContent = ok ? (card.getAttribute('data-pre') ? label('preorder', 'Pre-order', card) : label('add', 'Quick add', card)) : label('soldout', 'Sold out', card); }
add.setAttribute('aria-label', (ok ? (card.getAttribute('data-pre') ? 'Pre-order ' : 'Quick add ') : 'Sold out: ') + card.getAttribute('data-title'));
}
function paintCard(card) {
product(card.getAttribute('data-mbf-card')).then(function (p) {
if (!p) { return; }
if ((p.tags || []).indexOf('preorder_tag') > -1) { card.setAttribute('data-pre', '1'); }
$$('[data-v]', card).forEach(function (b) {
if (!b.classList.contains('mbf-var') && b.hasAttribute('data-mbf-qadd')) { return; }
var v = variantOf(p, b.getAttribute('data-v')); if (!v) { b.setAttribute('data-ok', '0'); return; }
b.setAttribute('data-price', v.price); b.setAttribute('data-was', v.compare_at_price || 0); b.setAttribute('data-ok', v.available ? '1' : '0');
});
cardState(card);
});
}

var cartReq = null;
function loadCart(force) {
if (DEMO) { return Promise.resolve(demoCart); }
if (cartReq && !force) { return cartReq; }
cartReq = window.fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
return cartReq;
}
function localMoney(cents) {
try { return new Intl.NumberFormat(lang === 'en' ? 'en-IE' : lang, { style: 'currency', currency: cur, currencyDisplay: 'code' }).format(cents / 100); }
catch (e) { return cur + ' ' + (cents / 100).toFixed(2); }
}
function eurThreshold(amount) {
return new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(amount) + ' EUR';
}
function paintThresholds() {
$$('[data-mbf-local-tier]').forEach(function (el) {
var euro = CFG.tiers[Number(el.getAttribute('data-mbf-local-tier')) - 1];
el.hidden = cur === 'EUR' || !rate;
if (!el.hidden) { el.textContent = '\u2248 ' + localMoney(Math.round(euro * 100 * rate)); }
});
$$('[data-mbf-currency-note]').forEach(function (el) {
el.textContent = cur === 'EUR' ? 'The highlighted row applies to your selected country.' : rate ? 'Shopping in ' + cur + '? The local-currency amounts below are approximate equivalents of the EUR thresholds. Your selected country determines the gift tier.' : 'Gift thresholds are in EUR. Select your delivery country to see the applicable region; local-currency equivalents are currently unavailable.';
});
}
function paintMeter(cart) {
var total = cart ? (cart.total_price || 0) : 0;
var canConvert = !!rate && (!cart || !cart.currency || cart.currency === cur);
var t1 = canConvert ? Math.round(CFG.tiers[0] * 100 * rate) : Infinity;
var t2 = canConvert ? Math.round(CFG.tiers[1] * 100 * rate) : Infinity;
var lvl = total >= t2 ? 2 : (total >= t1 ? 1 : 0);
$$('[data-mbf-meter]').forEach(function (m) {
var c = m.querySelector('[data-mbf-cart]'), msg = m.querySelector('[data-mbf-msg]'), fill = m.querySelector('.mbf-meter__fill');
if (c) { c.textContent = localMoney(total); }
if (fill) { fill.style.setProperty('--p', canConvert ? Math.min(1, total / t2).toFixed(4) : '0'); }
$$('.mbf-ms', m).forEach(function (ms) { ms.classList.toggle('is-on', lvl >= +ms.getAttribute('data-ms')); });
if (msg) {
msg.textContent = !canConvert ? 'Free gifts unlock at the EUR thresholds shown above.' : lvl === 2 ? '2 free Himalayan 45g jars unlocked' : lvl === 1 ? '1 free jar unlocked \u00b7 ' + localMoney(t2 - total) + ' more for 2' : localMoney(t1 - total) + ' to go for 1 free Himalayan 45g';
}
});
$$('[data-mbf-tier]').forEach(function (t) { t.classList.toggle('is-on', lvl >= +t.getAttribute('data-mbf-tier')); });
}
function refreshMeter() { if ($$('[data-mbf-meter]').length) { loadCart(true).then(paintMeter); } }

function themeDrawer() { var d = document.querySelector('cart-drawer'); return d && typeof d.show === 'function' ? d : null; }
function done(btn, text, cls) {
btn.removeAttribute('aria-busy'); btn.classList.add(cls);
var t = btn.querySelector('.mbf-btn__t') || btn.querySelector('.mbf-card__lbl'), old = t ? t.innerHTML : '';
if (t) { t.textContent = text; }
setTimeout(function () { btn.classList.remove(cls); if (t) { t.innerHTML = old; } }, 2400);
}
function add(variant, btn, after) {
if (!variant || btn.disabled || btn.getAttribute('aria-busy') === 'true') { return; }
btn.setAttribute('aria-busy', 'true');
if (DEMO) {
setTimeout(function () {
demoCart.total_price += +(btn.getAttribute('data-cents') || 0); demoCart.item_count += 1;
done(btn, label('added', 'Added to cart', btn), 'is-done'); paintMeter(demoCart); if (after) { after(); }
}, 600);
return;
}
var body = new FormData(); body.set('id', variant); body.set('quantity', '1');
var drawer = themeDrawer();
if (drawer) {
var sec = drawer.closest('.shopify-section');
body.set('sections', sec && sec.id ? sec.id.replace('shopify-section-', '') : 'cart-drawer');
body.set('sections_url', root + 'cart');
}
window.fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: body })
.then(function (r) { return r.json().then(function (j) { if (!r.ok) { j.__status = r.status; throw j; } return j; }); })
.then(function (added) {
done(btn, label('added', 'Added to cart', btn), 'is-done'); if (after) { after(); }
document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
loadCart(true).then(function (cart) {
paintMeter(cart);
if (drawer && cart) {
cart.sections = added.sections || {};
document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { items: added.items || [added], baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart } }));
setTimeout(function () { try { if (!drawer.hasAttribute('open')) { drawer.show(); } } catch (e) {} }, 350);
return;
}
var R = window.Rebuy;
if (R && R.SmartCart && typeof R.SmartCart.show === 'function') { setTimeout(function () { try { R.SmartCart.show(); } catch (e) {} }, 300); return; }
window.location.href = root + 'cart';
});
})
.catch(function (err) {
if (err && err.__status) { done(btn, label('unavailable', 'Not available', btn), 'is-err'); return; }
done(btn, label('error', 'Please try again', btn), 'is-err');
});
}

var lastFocus = null, openM = null, oldOverflow = '';
function openModal(key) {
var m = $$('[data-mbf-modal-key]').find(function (el) { return el.getAttribute('data-mbf-modal-key') === key; }); if (!m) { return; }
lastFocus = document.activeElement; openM = m;
oldOverflow = document.documentElement.style.overflow; m.hidden = false; document.documentElement.style.overflow = 'hidden';
var x = m.querySelector('.mbf-modal__x'); if (x) { setTimeout(function () { x.focus(); }, 30); }
}
function closeModal() {
if (!openM) { return; }
openM.hidden = true; openM = null; document.documentElement.style.overflow = oldOverflow;
if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
}
function addThumb(g, big, small, photo) {
var row = g.querySelector('.mbf-gal__thumbs'); if (!row) { return; }
var b = document.createElement('button'); b.type = 'button'; b.setAttribute('data-big', big); if (photo) { b.setAttribute('data-photo', '1'); }
b.setAttribute('aria-label', 'Show image ' + (row.children.length + 1));
var i = document.createElement('img'); i.src = small; i.alt = ''; i.loading = 'lazy'; b.appendChild(i);
row.appendChild(b); bindThumb(g, b);
}
function show(g, b) {
var main = g.querySelector('.mbf-gal__main img'); if (!main || !b) { return; }
$$('.mbf-gal__thumbs button', g).forEach(function (x) { x.classList.toggle('is-on', x === b); });
main.style.opacity = '0';
setTimeout(function () { main.removeAttribute('srcset'); main.src = b.getAttribute('data-big'); if (b.getAttribute('data-alt')) { main.alt = b.getAttribute('data-alt'); } main.classList.toggle('is-photo', !!b.getAttribute('data-photo')); main.style.opacity = '1'; }, 160);
}
function bindThumb(g, b) { b.addEventListener('click', function () { show(g, b); }); }
function step(g, dir) {
var t = $$('.mbf-gal__thumbs button', g); if (!t.length) { return; }
var i = t.indexOf(g.querySelector('.mbf-gal__thumbs button.is-on')); show(g, t[(i + dir + t.length) % t.length]);
}
function galNav(g) { var n = $$('.mbf-gal__thumbs button', g).length; $$('.mbf-gal__nav', g).forEach(function (a) { a.hidden = n < 2; }); }
function bindGal(g) {
$$('.mbf-gal__thumbs button', g).forEach(function (b) { bindThumb(g, b); });
var l = g.querySelector('.mbf-gal__nav--l'), r = g.querySelector('.mbf-gal__nav--r');
if (l) { l.addEventListener('click', function () { step(g, -1); }); }
if (r) { r.addEventListener('click', function () { step(g, 1); }); }
var x0 = null, main = g.querySelector('.mbf-gal__main');
main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
main.addEventListener('touchend', function (e) { if (x0 === null) { return; } var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { step(g, dx < 0 ? 1 : -1); } x0 = null; });
galNav(g);
}
function bindTabs(m) {
var tabs = $$('.mbf-tab', m);
tabs.forEach(function (t, index) {
t.addEventListener('keydown', function (event) {
var next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : -1;
if (next > -1) { event.preventDefault(); tabs[next].click(); tabs[next].focus(); }
});
t.addEventListener('click', function () {
tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; });
$$('.mbf-panel', m).forEach(function (p) { p.hidden = p.id !== t.getAttribute('aria-controls'); });
});
});
}
document.addEventListener('keydown', function (e) {
if (!openM) { return; }
if (e.key === 'Escape') { closeModal(); return; }
if (e.key === 'Tab') {
var f = $$('button:not([disabled]),a[href]', openM).filter(function (x) { return x.offsetParent !== null; });
if (!f.length) { return; }
if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
}
});

function go(id) { var el = document.querySelector('[data-mbf-anchor="' + id + '"]'); if (el) { window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 70, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); } }
var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }) : null;
var vis = { hero: false, final: false };
var so = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
es.forEach(function (e) { vis[e.target.getAttribute('data-mbf-zone')] = e.isIntersecting; });
$$('.mbf-sticky').forEach(function (b) { b.classList.toggle('is-on', !vis.hero && !vis.final); });
}, { threshold: 0 }) : null;
function portal(el) {
if (el.parentElement && el.parentElement.classList.contains('mbf-portal')) { return; }
var owner = el.closest('[data-mbf-section]');
var p = document.createElement('div'); p.className = 'mbf mbf-portal'; p.setAttribute('data-mbf2', '1');
if (owner) {
p.setAttribute('data-mbf-owner', owner.getAttribute('data-mbf-section'));
var style = getComputedStyle(owner);
['--bk', '--ink', '--g'].forEach(function (key) { p.style.setProperty(key, style.getPropertyValue(key)); });
}
document.body.appendChild(p); p.appendChild(el);
}
function scan() {
configure();
paintThresholds();
$$('.mbf').forEach(function (r) {
if (r.getAttribute('data-mbf2')) { return; }
r.setAttribute('data-mbf2', '1');
if (io && !matchMedia('(prefers-reduced-motion: reduce)').matches) { r.classList.add('mbf-js'); $$('[data-rev]', r).forEach(function (el) { io.observe(el); }); }
$$('[data-mbf-zone]', r).forEach(function (z) { if (so) { so.observe(z); } });
$$('[data-mbf-go]', r).forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); go(a.getAttribute('data-mbf-go')); }); });
$$('[data-mbf-open]', r).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openModal(b.getAttribute('data-mbf-open')); }); });
$$('.mbf-modal', r).forEach(function (m) {
$$('[data-mbf-close]', m).forEach(function (c) { c.addEventListener('click', closeModal); });
$$('[data-mbf-buy]', m).forEach(function (b) {
b.addEventListener('click', function () {
var k = b.getAttribute('data-mbf-buy');
add(CFG.deals[k] && CFG.deals[k].available !== false && CFG.deals[k].variant, b, function () { setTimeout(closeModal, 700); });
});
});
bindTabs(m); $$('[data-mbf-gal]', m).forEach(bindGal);
});
$$('[data-mbf-card]', r).forEach(function (card) {
$$('.mbf-var', card).forEach(function (b) {
b.addEventListener('click', function () { $$('.mbf-var', card).forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); cardState(card); });
});
var q = card.querySelector('[data-mbf-qadd]');
q.addEventListener('click', function () { add(q.getAttribute('data-v'), q); });
paintCard(card);
});
$$('[data-mbf-price]', r).forEach(function (b) { var k = b.getAttribute('data-mbf-price'); if (CFG.deals[k]) { paintDeal(k); } });
if (r.querySelector('[data-mbf-meter]')) { loadCart().then(paintMeter); }
});
$$('.mbf-sticky,.mbf-modal').forEach(portal);
if (ShopifyDesignMode()) { $$('[data-rev]').forEach(function (el) { el.classList.add('is-in'); }); }
paintRegs();
tick();
}
function ShopifyDesignMode() { return window.Shopify && window.Shopify.designMode; }
document.addEventListener('shopify:section:load', scan);
document.addEventListener('shopify:section:reorder', scan);
document.addEventListener('shopify:section:unload', function (event) {
var id = event.detail && event.detail.sectionId;
$$('[data-mbf-owner]').forEach(function (p) {
if (p.getAttribute('data-mbf-owner') === id) {
if (openM && p.contains(openM)) { closeModal(); }
p.remove();
}
});
$$('[data-mbf-zone],[data-rev]', event.target).forEach(function (el) { if (io) { io.unobserve(el); } if (so) { so.unobserve(el); } });
var zone = event.target.querySelector('[data-mbf-zone]');
if (zone) { vis[zone.getAttribute('data-mbf-zone')] = false; }
});
document.addEventListener('shopify:block:select', function (event) {
var id = event.detail && event.detail.blockId;
$$('[data-mbf-modal-key]').forEach(function (m) { if (m.getAttribute('data-shopify-editor-block') && m.getAttribute('data-shopify-editor-block').indexOf(id) > -1) { openModal(m.getAttribute('data-mbf-modal-key')); } });
});
window.__MD_BLACK_FRIDAY = { scan: scan, config: CFG, open: openModal };
setInterval(tick, 1000);
['cart:updated', 'rebuy:cart.change', 'cart:refresh', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, function (e) { if (e.detail && e.detail.cart) { paintMeter(e.detail.cart); } else { setTimeout(refreshMeter, 400); } }); });
window.addEventListener('pageshow', function (e) { if (e.persisted) { refreshMeter(); } });
scan();
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); }
})();
